module.exports = __webpack_public_path__ + "img/Egypt-sm.22a84746.jpg";